var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuanta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 217.1,
    height: 38.4,
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00CCBE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.2 4.6h-.6V1.9h-1v-.5h2.6v.5h-1v2.7zM212.9 3.8l-1-1.5v2.3h-.5V1.4h.6l1 1.5 1-1.5h.6v3.2h-.6V2.3l-1.1 1.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00CCBE",
    d: "M35.8 34.3l-4.2-4.9c-1.4 1.6-3 3-4.9 4.1l4.2 4.9 4.9-4.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D1E5F",
    d: "M35.7 17.8C35.7 7.8 27.9 0 17.8 0S0 7.8 0 17.8c0 10.1 7.8 17.8 17.8 17.8 3.2 0 6.3-.7 8.9-2.2 0 0-2.7-3.3-3.2-3.8s-.8-.8-1.3-1c-.6-.2-1-.1-1.7 0-.9.3-1.8.4-2.7.4-6.3 0-11.2-4.9-11.2-11.2S11.5 6.6 17.8 6.6 29 11.5 29 17.8c0 1.7-.4 3.3-1 4.7-.2.5-.3 1-.3 1.6.1.5.3.9.8 1.5.7.9 3.2 3.7 3.2 3.7 2.5-3.1 4-7.1 4-11.5zM57.7 28.4c-2.4 0-4.6-.8-6-2.4-1.6-1.9-1.9-3.9-1.9-6.3V4c0-.9-.2-1.5-.7-2s-1.1-.7-2-.7h-4.3v17.5c0 5.9.9 8.7 4 11.9 2.5 2.6 6.6 4 10.9 4v-6.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CCBE",
    d: "M57.7 34.8c4.3 0 8.4-1.4 10.9-4 3.1-3.2 4-6 4-11.9V1.4h-6.9v18.3c0 2.9-.5 4.6-1.9 6.3-1.3 1.5-3.6 2.4-6 2.4l-.1 6.4zM93.3 10.5l9.9 23.8h7.8L96.9 1.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D1E5F",
    d: "M96.9 1.4h-4.6c-1.6 0-2.8.8-3.4 2.1-1.4 3.3-13.2 30.8-13.2 30.8h5.1c1.6 0 2.9-.8 3.4-2.1 1.4-3.3 9.1-21.6 9.1-21.6l3.6-9.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CCBE",
    d: "M199.4 10.5l10 23.8h7.7L203 1.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D1E5F",
    d: "M203 1.4h-4.6c-1.6 0-2.8.8-3.4 2.1-1.4 3.3-13.2 30.8-13.2 30.8h5.1c1.6 0 2.9-.8 3.4-2.1 1.4-3.3 9.1-21.6 9.1-21.6l3.6-9.2zM139.3 21.8S126.3 4.7 125 3.1c-1-1.3-1.8-1.6-3.4-1.6h-4.7v32.9h4.5c1.5 0 2.5-1 2.5-2.5V13.2s13.8 18.2 15 19.7c.8 1.1 1.9 1.5 3.2 1.5h4.2V31l-7-9.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CCBE",
    d: "M146.3 30.9V1.4h-7v20.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D1E5F",
    d: "M171.5 1.4h-17.1v4.3c0 1.5 1 2.5 2.5 2.5h7.7v23.6c0 1.5 1 2.5 2.5 2.5h4.5V8.2l-.1-6.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CCBE",
    d: "M171.5 1.4h10.2v6.8h-10.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuanta);
export default __webpack_public_path__ + "static/media/quanta.f44a1c927b503e11ba01930efdb77e9a.svg";
export { ForwardRef as ReactComponent };